import React from 'react';

import Button, { ButtonProps } from '@material-ui/core/Button';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = () =>
  createStyles({
    textButton: {
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    variantBigUnderline: {
      fontSize: 15,
      textDecoration: 'underline',
    },
    variantCancel: {
      fontSize: 15,
      fontWeight: 600,
    },
    variantSmallUnderline: {
      fontSize: 12,
      textDecoration: 'underline',
    },
  });

export interface TextButtonProps extends Omit<ButtonProps, 'classes' | 'variant'>, WithStyles<typeof styles> {
  variant?: 'bigUnderline' | 'cancel' | 'smallUnderline';
}

const TextButton: React.FC<TextButtonProps> = ({ classes, className, children, variant, ...rest }) => (
  <Button
    className={classNames(
      classes.textButton,
      {
        [classes.variantBigUnderline]: variant === 'bigUnderline',
        [classes.variantCancel]: variant === 'cancel',
        [classes.variantSmallUnderline]: variant === 'smallUnderline',
      },
      className,
    )}
    component="button"
    variant="text"
    {...rest}
  >
    {children}
  </Button>
);

export default withStyles(styles)(TextButton);
